import { useContext } from 'react';
import { StateContext } from '../../state/contexts';
import Option from '../types/option';
import useFiltersWithout from './use-filters-without';
import FiltersState, { StateOf, ValueOf } from '../state/filters-state';

type SupportedFilters = Omit<FiltersState, 'maps' | 'keywords'>;

const useOptions = <Key extends keyof SupportedFilters>(
  key: Key,
  // eslint-disable-next-line no-unused-vars
  id: (value: ValueOf<Key>) => string,
): Option[] => {
  const state = useContext(StateContext);
  const { config, filters } = state;
  const filter: StateOf<Key> = filters[key];

  const jobsFiltered = useFiltersWithout(key);

  return filter.available
    .map((value: any) => {
      const matches =
        typeof filter.filterFunction !== 'undefined' ? filter.filterFunction(jobsFiltered, [id(value)]).length : 0;
      return { value: id(value), label: value?.name, matches };
    })
    .filter(
      (option) => option.matches > 0 || config.config.ui.showEmptyChoices || filter.selected.includes(option.value),
    );
};

export default useOptions;
